/**
 * Tracks whether a tooltip group is "warmed up" — i.e., the user has been
 * hovering long enough that the first tooltip has appeared. Subsequent tooltips
 * in the group should appear instantly until the mouse leaves.
 */
export const useTooltipWarmup = (baseDelayMS: number, cooldownMS = 400) => {
  let isWarmedUp = $state(false);
  let warmupTimer: ReturnType<typeof setTimeout> | undefined;
  let cooldownTimer: ReturnType<typeof setTimeout> | undefined;

  const delay = $derived(isWarmedUp ? 0 : baseDelayMS);

  const onGroupMouseEnter = () => {
    clearTimeout(cooldownTimer);
    if (!isWarmedUp) {
      warmupTimer = setTimeout(() => {
        isWarmedUp = true;
      }, baseDelayMS);
    }
  };

  const onGroupMouseLeave = () => {
    clearTimeout(warmupTimer);
    warmupTimer = undefined;
    cooldownTimer = setTimeout(() => {
      isWarmedUp = false;
    }, cooldownMS);
  };

  return {
    get delay() {
      return delay;
    },
    onGroupMouseEnter,
    onGroupMouseLeave,
  };
};
